module.exports = __webpack_public_path__ + "img/clone.0cc43469.svg";